const QueryType = {
    PATIENT_DISCOVERY: 'patientDiscovery',
    QUERY_DOCUMENT: 'queryDocument',
    RETRIEVE_DOCUMENT: 'retrieveDocument',
    MEDICATIONS: 'medications',
};

export default QueryType;
